import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ButtonComponent from "../generic/ButtonComponent";
import Modal from "../generic/Modal/Modal";
import { segmentAnalytics } from "../services/Analytics";
import "./ShopifySubscriptionAlert.scss";
import {
  SHOPIFY_SUBSCRIPTION_APPROVAL_BUTTON_CLICKED,
  SHOPIFY_SUBSCRIPTION_BANNER_DIMISSED,
} from "../../constants/eventsTracked";

interface ShopifySubscriptionAlertProps {
  confirmationUrl?: string;
  forceShow?: boolean;
}

export function ShopifySubscriptionAlert(props: ShopifySubscriptionAlertProps) {
  const { confirmationUrl, forceShow = false } = props;
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current !== pathname) {
      setDismissed(false);
      previousPathname.current = pathname;
    }
  }, [pathname]);

  const hideNotification = () => {
    segmentAnalytics.track(SHOPIFY_SUBSCRIPTION_BANNER_DIMISSED);
    setDismissed(true);
  };

  if (!confirmationUrl || dismissed) return null;

  return (
    <Modal onClose={hideNotification} className="ShopifySubscriptionAlert">
      <Modal.Header>Shopify Subscription Pending</Modal.Header>
      <Modal.Content>
        <p>
          Your Shopify subscription is pending confirmation. In order to
          continue using BinderPOS, this subscription must be approved.
        </p>
        <p>
          Additional details, including information on commission fees, have
          been sent via email. Please proceed to your{" "}
          <a
            href={confirmationUrl}
            title="Shopify Subscription Acceptance Page"
            rel="noreferrer"
            target="_blank"
          >
            MyShopify
          </a>{" "}
          to approve this subscription.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <ButtonComponent
          primary
          fullWidth
          href={confirmationUrl}
          rel="noreferrer"
          title="Shopify Subscription Acceptance Page"
          target="_blank"
          isAnchor
          segmentEventName={SHOPIFY_SUBSCRIPTION_APPROVAL_BUTTON_CLICKED}
        >
          Approve Subscription Now
        </ButtonComponent>
      </Modal.Actions>
    </Modal>
  );
}

export default ShopifySubscriptionAlert;
